import { generateRecentTimestamp } from "utils/timestamp";

const routesInfo = {
  routesInfo: {
    route: "Route#123",
    totalBuses: "475",
    avgRevenue: "$124K",
    regionDepot: "Costa Rica",
    totalTrips: "17451",
    safetyScore: "75",
    fuelUsage: "20 Gal",
    totalPassengers: "25896",
    totalHours: "255467",
    totalViolations: "578",
    totalMiles: "1500",
   trips: [
      {
        tripNo: "1",
        tripStatus: "In Progress",
        totalOccupancy: "20/40",
        busId: "Bus#123",
        fuelConsumed: "20 Gal",
        distanceCovered: "20 Miles",
        distance: "150 Miles",
        stops: "03",
        driver: "Tim John",
        occupancy: "80",
        safetyScore: "75",
        harshAccelaration: "00",
        overspeeding: "10",
        corner: "0",
        fuelEfficiency: "12",
        harshBraking: "0",
        idleHours: "0",
        routeDetails: {
          route: "Route#123",
          routeStops: {
            totalStops: "5",
            stopsCovered: "3",
            stoppages: [
              {
                name: "Source",
                observation: "15 Min Delay",
                area: "Mussafah, Abu Dhabi",
                coOrdinates: { lat: "", lng: "" },
                timeStamp: generateRecentTimestamp(),
              },
              {
                name: "Current Location",
                observation: "Over Speeding",
                area: "Shahama, Abu Dhabi",
                coOrdinates: { lat: "", lng: "" },
                timeStamp: generateRecentTimestamp(),
              },
              {
                name: "Stop 1",
                observation: "Next Stop",
                area: "Yas Island, Abu Dhabi",
                coOrdinates: { lat: "", lng: "" },
                timeStamp: generateRecentTimestamp(),
              },
              {
                name: "Stop 2",
                observation: "",
                area: "Saadiyat Island, Abu Dhabi",
                coOrdinates: { lat: "", lng: "" },
                timeStamp: generateRecentTimestamp(),
              },
              {
                name: "Stop 3",
                observation: "",
                area: "Al Reem Island, Abu Dhabi",
                coOrdinates: { lat: "", lng: "" },
                timeStamp: generateRecentTimestamp(),
              },
              {
                name: "Destination",
                observation: "",
                area: "Abu Dhabi Corniche",
                coOrdinates: { lat: "", lng: "" },
                timeStamp: generateRecentTimestamp(),
              },
            ],
          },
        },
      },
      {
        tripNo: "2",
        tripStatus: "In Progress",
        totalOccupancy: "25/45",
        busId: "Bus#124",
        fuelConsumed: "22 Gal",
        distanceCovered: "25 Miles",
        distance: "160 Miles",
        stops: "03",
        driver: "Mohammed Ali",
        occupancy: "85",
        safetyScore: "80",
        harshAccelaration: "01",
        overspeeding: "08",
        corner: "1",
        fuelEfficiency: "13",
        harshBraking: "0",
        idleHours: "1",
        routeDetails: {
          route: "Route#124",
          routeStops: {
            totalStops: "5",
            stopsCovered: "3",
            stoppages: [
              { name: "Source", area: "Al Ain, Abu Dhabi", observation: "On Time", coOrdinates: { lat: "", lng: "" }, timeStamp: generateRecentTimestamp() },
              { name: "Current Location", area: "Baniyas, Abu Dhabi", observation: "Smooth Drive", coOrdinates: { lat: "", lng: "" }, timeStamp: generateRecentTimestamp() },
              { name: "Stop 1", area: "Shakhbout City, Abu Dhabi", observation: "Next Stop", coOrdinates: { lat: "", lng: "" }, timeStamp: generateRecentTimestamp() },
              { name: "Stop 2", area: "Al Mafraq, Abu Dhabi", observation: "", coOrdinates: { lat: "", lng: "" }, timeStamp: generateRecentTimestamp() },
              { name: "Destination", area: "Abu Dhabi Downtown", observation: "", coOrdinates: { lat: "", lng: "" }, timeStamp: generateRecentTimestamp() },
            ],
          },
        },
      },
      {
        tripNo: "3",
        tripStatus: "Completed",
        totalOccupancy: "30/50",
        busId: "Bus#125",
        fuelConsumed: "24 Gal",
        distanceCovered: "100 Miles",
        distance: "200 Miles",
        stops: "04",
        driver: "Ahmed Khan",
        occupancy: "90",
        safetyScore: "85",
        harshAccelaration: "02",
        overspeeding: "12",
        corner: "2",
        fuelEfficiency: "11",
        harshBraking: "1",
        idleHours: "2",
        routeDetails: {
          route: "Route#125",
          routeStops: {
            totalStops: "6",
            stopsCovered: "6",
            stoppages: [
              { name: "Source", area: "Ruwais, Abu Dhabi", observation: "Started", coOrdinates: { lat: "", lng: "" }, timeStamp: generateRecentTimestamp() },
              { name: "Stop 1", area: "Madinat Zayed, Abu Dhabi", observation: "", coOrdinates: { lat: "", lng: "" }, timeStamp: generateRecentTimestamp() },
              { name: "Stop 2", area: "Liwa Oasis, Abu Dhabi", observation: "", coOrdinates: { lat: "", lng: "" }, timeStamp: generateRecentTimestamp() },
              { name: "Stop 3", area: "Al Dhafra, Abu Dhabi", observation: "", coOrdinates: { lat: "", lng: "" }, timeStamp: generateRecentTimestamp() },
              { name: "Destination", area: "Abu Dhabi Central Bus Station", observation: "", coOrdinates: { lat: "", lng: "" }, timeStamp: generateRecentTimestamp() },
            ],
          },
        },
      },
      // Repeat similar for trips 4–7 with other Abu Dhabi areas
    ],
    pastViolations: [
      { violationType: "overspeeding", busNo: "123", route: "Route#1", timeStamp: generateRecentTimestamp() },
      { violationType: "harsh braking", busNo: "124", route: "Route#2", timeStamp: generateRecentTimestamp() },
      { violationType: "overspeeding", busNo: "125", route: "Route#3", timeStamp: generateRecentTimestamp() },
      { violationType: "idle time excess", busNo: "126", route: "Route#4", timeStamp: generateRecentTimestamp() },
      { violationType: "overspeeding", busNo: "127", route: "Route#5", timeStamp: generateRecentTimestamp() },
    ],
  },
};
export default routesInfo;



















// import { generateRecentTimestamp } from "utils/timestamp";

// // Helper function to generate different route data
// const generateRouteData = (routeId, routeName) => ({
//   route: `Route#${routeId}`,
//   routeName: routeName,
//   totalBuses: Math.floor(Math.random() * 500) + 100,
//   avgRevenue: `$${Math.floor(Math.random() * 200) + 50}K`,
//   regionDepot: ["Costa Rica", "San Jose", "Cartago", "Alajuela"][Math.floor(Math.random() * 4)],
//   totalTrips: Math.floor(Math.random() * 20000) + 5000,
//   safetyScore: Math.floor(Math.random() * 40) + 60,
//   fuelUsage: `${Math.floor(Math.random() * 30) + 10} Gal`,
//   totalPassengers: Math.floor(Math.random() * 30000) + 10000,
//   totalHours: Math.floor(Math.random() * 300000) + 100000,
//   totalViolations: Math.floor(Math.random() * 1000) + 100,
//   totalMiles: Math.floor(Math.random() * 2000) + 500,
// });

// const routesInfo = {
//   routesInfo: generateRouteData(123, "Central Route"),
//   routes: [
//     {
//       ...generateRouteData(123, "Central Route"),
//       trips: [
//         {
//           tripNo: "1",
//           tripStatus: "In Progress",
//           totalOccupancy: "20/40",
//           busId: "Bus#123",
//           fuelConsumed: "20 Gal",
//           distanceCovered: "20 Miles",
//           distance: "150 Miles",
//           stops: "03",
//           driver: "Tim John",
//           occupancy: "80",
//           safetyScore: "75",
//           harshAccelaration: "00",
//           overspeeding: "10",
//           corner: "0",
//           fuelEfficiency: "12",
//           harshBraking: "0",
//           idleHours: "0",
//           routeDetails: {
//             route: "Route#123",
//             routeStops: {
//               totalStops: "5",
//               stopsCovered: "3",
//               stoppages: [
//                 {
//                   name: "Source",
//                   observation: "15 Min Delay",
//                   area: "Florrencia, Costa Rica",
//                   coOrdinates: { lat: "", lng: "" },
//                   timeStamp: generateRecentTimestamp(),
//                 },
//                 {
//                   name: "Current Location",
//                   observation: "Over Speeding",
//                   area: "San Carlos, Costa Rica",
//                   coOrdinates: { lat: "", lng: "" },
//                   timeStamp: generateRecentTimestamp(),
//                 },
//                 {
//                   name: "Stop 1",
//                   observation: "Next Stop",
//                   area: "San Jose, Costa Rica",
//                   coOrdinates: { lat: "", lng: "" },
//                   timeStamp: generateRecentTimestamp(),
//                 },
//                 {
//                   name: "Stop 2",
//                   observation: "",
//                   area: "Mirador, Costa Rica",
//                   coOrdinates: { lat: "", lng: "" },
//                   timeStamp: generateRecentTimestamp(),
//                 },
//                 {
//                   name: "Stop 3",
//                   observation: "",
//                   area: "Pataste, Costa Rica",
//                   coOrdinates: { lat: "", lng: "" },
//                   timeStamp: generateRecentTimestamp(),
//                 },
//                 {
//                   name: "Destination",
//                   observation: "",
//                   area: "Jicarito, Costa Rica",
//                   coOrdinates: { lat: "", lng: "" },
//                   timeStamp: generateRecentTimestamp(),
//                 },
//               ],
//             },
//           },
//         },
//         // Add more trips for Route#123...
//       ],
//       pastViolations: [
//         {
//           violationType: "overspeeding",
//           busNo: "123",
//           route: "Route#123",
//           timeStamp: generateRecentTimestamp(),
//         },
//         {
//           violationType: "harsh braking",
//           busNo: "124",
//           route: "Route#123",
//           timeStamp: generateRecentTimestamp(),
//         },
//       ]
//     },
//     {
//       ...generateRouteData(124, "Northern Route"),
//       trips: [
//         {
//           tripNo: "1",
//           tripStatus: "Completed",
//           totalOccupancy: "35/45",
//           busId: "Bus#124",
//           fuelConsumed: "25 Gal",
//           distanceCovered: "180 Miles",
//           distance: "180 Miles",
//           stops: "05",
//           driver: "Maria Santos",
//           occupancy: "85",
//           safetyScore: "88",
//           harshAccelaration: "02",
//           overspeeding: "05",
//           corner: "1",
//           fuelEfficiency: "15",
//           harshBraking: "1",
//           idleHours: "2",
//           routeDetails: {
//             route: "Route#124",
//             routeStops: {
//               totalStops: "6",
//               stopsCovered: "6",
//               stoppages: [
//                 {
//                   name: "Source",
//                   observation: "On Time",
//                   area: "Alajuela, Costa Rica",
//                   coOrdinates: { lat: "", lng: "" },
//                   timeStamp: generateRecentTimestamp(),
//                 },
//                 {
//                   name: "Stop 1",
//                   observation: "",
//                   area: "Heredia, Costa Rica",
//                   coOrdinates: { lat: "", lng: "" },
//                   timeStamp: generateRecentTimestamp(),
//                 },
//                 {
//                   name: "Stop 2",
//                   observation: "",
//                   area: "Cartago, Costa Rica",
//                   coOrdinates: { lat: "", lng: "" },
//                   timeStamp: generateRecentTimestamp(),
//                 },
//                 {
//                   name: "Stop 3",
//                   observation: "",
//                   area: "Turrialba, Costa Rica",
//                   coOrdinates: { lat: "", lng: "" },
//                   timeStamp: generateRecentTimestamp(),
//                 },
//                 {
//                   name: "Stop 4",
//                   observation: "",
//                   area: "Limon, Costa Rica",
//                   coOrdinates: { lat: "", lng: "" },
//                   timeStamp: generateRecentTimestamp(),
//                 },
//                 {
//                   name: "Destination",
//                   observation: "",
//                   area: "Puerto Viejo, Costa Rica",
//                   coOrdinates: { lat: "", lng: "" },
//                   timeStamp: generateRecentTimestamp(),
//                 },
//               ],
//             },
//           },
//         },
//       ],
//       pastViolations: [
//         {
//           violationType: "speeding",
//           busNo: "124",
//           route: "Route#124",
//           timeStamp: generateRecentTimestamp(),
//         },
//         {
//           violationType: "idle time excess",
//           busNo: "125",
//           route: "Route#124",
//           timeStamp: generateRecentTimestamp(),
//         },
//       ]
//     },
//     {
//       ...generateRouteData(125, "Southern Route"),
//       trips: [
//         {
//           tripNo: "1",
//           tripStatus: "In Progress",
//           totalOccupancy: "28/50",
//           busId: "Bus#125",
//           fuelConsumed: "18 Gal",
//           distanceCovered: "95 Miles",
//           distance: "200 Miles",
//           stops: "04",
//           driver: "Carlos Rodriguez",
//           occupancy: "56",
//           safetyScore: "92",
//           harshAccelaration: "01",
//           overspeeding: "02",
//           corner: "0",
//           fuelEfficiency: "18",
//           harshBraking: "0",
//           idleHours: "1",
//           routeDetails: {
//             route: "Route#125",
//             routeStops: {
//               totalStops: "7",
//               stopsCovered: "4",
//               stoppages: [
//                 {
//                   name: "Source",
//                   observation: "On Time",
//                   area: "San Jose, Costa Rica",
//                   coOrdinates: { lat: "", lng: "" },
//                   timeStamp: generateRecentTimestamp(),
//                 },
//                 {
//                   name: "Current Location",
//                   observation: "Normal Speed",
//                   area: "Perez Zeledon, Costa Rica",
//                   coOrdinates: { lat: "", lng: "" },
//                   timeStamp: generateRecentTimestamp(),
//                 },
//                 {
//                   name: "Stop 1",
//                   observation: "Next Stop",
//                   area: "San Isidro, Costa Rica",
//                   coOrdinates: { lat: "", lng: "" },
//                   timeStamp: generateRecentTimestamp(),
//                 },
//                 {
//                   name: "Stop 2",
//                   observation: "",
//                   area: "Palmar Norte, Costa Rica",
//                   coOrdinates: { lat: "", lng: "" },
//                   timeStamp: generateRecentTimestamp(),
//                 },
//                 {
//                   name: "Stop 3",
//                   observation: "",
//                   area: "Golfito, Costa Rica",
//                   coOrdinates: { lat: "", lng: "" },
//                   timeStamp: generateRecentTimestamp(),
//                 },
//                 {
//                   name: "Stop 4",
//                   observation: "",
//                   area: "Puerto Jimenez, Costa Rica",
//                   coOrdinates: { lat: "", lng: "" },
//                   timeStamp: generateRecentTimestamp(),
//                 },
//                 {
//                   name: "Destination",
//                   observation: "",
//                   area: "Corcovado, Costa Rica",
//                   coOrdinates: { lat: "", lng: "" },
//                   timeStamp: generateRecentTimestamp(),
//                 },
//               ],
//             },
//           },
//         },
//       ],
//       pastViolations: [
//         {
//           violationType: "maintenance overdue",
//           busNo: "125",
//           route: "Route#125",
//           timeStamp: generateRecentTimestamp(),
//         },
//       ]
//     }
//   ]
// };

// export default routesInfo;
